import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="bg-surface border border-white/10 rounded-md p-10 max-w-md w-full text-center" data-testid="payment-cancel">
        <XCircle className="w-12 h-12 text-white/40 mx-auto mb-4" />
        <h1 className="font-heading text-2xl mb-2">Checkout canceled</h1>
        <p className="text-white/50 text-sm mb-6">No worries — you weren't charged. Come back whenever you're ready.</p>
        <Link to="/pricing" data-testid="back-pricing" className="bg-brand hover:bg-brand-hover text-white rounded-md px-6 py-2.5 text-sm font-medium transition-colors inline-block">Back to Pricing</Link>
      </div>
    </div>
  );
}
